import React from "react";
import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { Store } from "../src/redux/Store";

// import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Categories from "./views/Category/Categories";
import Subcategories from "./views/Category/Subcategories";
import Attributes from "./views/Category/Attributes";
import Left_panel from "./views/Left_panel";
import Index from "./views/Index";
import Login from "./views/Login";
import Forgot_password from "./views/Forgot_password";
import Sub_header from "./views/Sub_header";

import Country_list from "./views/location/Country_list";
import State_list from "./views/location/State_list";
import City_list from "./views/location/City_list";
import PostalCodes from "./views/location/PostalCodes";

import { Master_settings } from "./views/General_Settings/Master_settings";
import Payment_settings from "./views/General_Settings/Payment_settings";
import Social_settings from "./views/General_Settings/Social_settings";
import System_settings from "./views/General_Settings/System_settings";
import Smtp_settings from "./views/General_Settings/Smtp_settings";
import Shipments from "./views/Shipments/Shipments";
import Shipment_detail from "./views/Shipments/Shipment_detail";
import Print_receipts from "./views/Shipments/Print_receipts";
import Print_invoice from "./views/Shipments/Print_invoice";

import Payments from "./views/Payments/Payments";
import User_cod_wallet from "./views/Payments/User_cod_wallet";

import Transporter_detail from "./views/Transporter/Transporter_detail";
import Transporters from "./views/Transporter/Transporters";
import Transporter_wallet from "./views/Transporter/Transporter_wallet";
import Users from "./views/Users/Users";
import Agents from "./views/Users/Agents";

import User_detail from "./views/Users/User_detail";
import Vehicle_attributes from "./views/Vehicle/Vehicle_attributes";
import Email_template from "./views/Email_template/Email_template";
import Edit_global_email_template from "./views/Email_template/Edit_global_email_template";
import Edit_email_template from "./views/Email_template/Edit_email_template";
import Spam_report from "./views/Spam_Report/Spam_report";

import { Web_management } from "./views/Web_Management/Web_management";

import Cms_management from "./views/CMS_Management/Cms_management";
import My_profile from "./views/Profile/My_profile";
import Change_password from "./views/Profile/Change_password";
import Models_pop from "./views/Models_pop";
import Cms_edit from "./views/CMS_Management/Cms_edit";

import Vehicle_sub_attributes from "./views/Vehicle/Vehicle_sub_attributes";

import Ck_email_template from "./views/Ck_email_template";

import Admin_payments from "./views/Payments/Admin_payments";
import Transporter_payments from "./views/Payments/Transporter_payments";
import Add_group_value from "./views/Category/Add_group_value";
import Customers from "./views/Customers/Customers";
import Customers_info from "./views/Customers/Customers_info";
import Carrier_list from "./views/General_Settings/Carrier_list";
import Product_type from "./views/General_Settings/Product_type";
import Master from "./views/General_Settings/Master";
import Product from "./views/Product_management/Product";
import Add_product from "./views/Product_management/Add_product";
import Product_details from "./views/Product_management/Product_details";
import Product_details_source_city from "./views/Product_management/Product_details_source_city";
import Product_details_zone from "./views/Product_management/Product_details_zone";
import Import_process from "./views/Product_management/Import_process";
import Rate_calculator from "./views/Rate_calculator";
import Print_label from "./views/Shipments/Print_label";
import Master_new from "./views/General_Settings/Master_new";
import Log_view from "./views/Product_management/Log_view";
import Wallet_payment from "./views/Payments/Wallet_payment";
import Payment_gateway from "./views/Payments/Payment_gateway";
import Edit_product from "./views/Product_management/Edit_product";
import My_orders from "./views/Shipments/My_orders";
import Ship_1 from "./views/Shipments/Ship_1";
import My_address from "./views/Shipments/My_address";
import Ship_2 from "./views/Shipments/Ship_2";
import Package_list from "./views/Shipments/Package_list";
import Payment_details from "./views/Shipments/Payment_details";
import Summary from "./views/Shipments/Summary";
import Products from "./views/Product_management/Products";
import Product_detail from "./views/Product_management/Product_detail";
import Zone_management from "./views/Product_management/Zone_management";
import Special_zone from "./views/Product_management/Special_zone";
import Zone_metro_to_metro from "./views/Product_management/Zone_metro_to_metro";
import Special_zone_import_process from "./views/Product_management/Special_zone_import_process";
import Special_zone_log_view from "./views/Product_management/Special_zone_log_view";
import Metro_import_process from "./views/Product_management/Metro_import_process";
import Metro_zone_log_view from "./views/Product_management/Metro_zone_log_view";
import Servicable_pincode_import_process from "./views/General_Settings/Servicable_pincode_import_process";
import Servicable_pincodes from "./views/General_Settings/Servicable_pincodes";
import Servicable_pincodes_list from "./views/General_Settings/Servicable_pincodes_list";
import Weight_discrepancies from "./views/General_Settings/Weight_discrepancies";
import Weight_discrepancies_log from "./views/General_Settings/Weight_discrepancies_log";
import Customer_kyc_settings from "./views/Customer_kyc_settings";
import New_custromer_registration from "./views/New_custromer_registration";
import Sms_gateway_settings from "./views/Sms_gateway_settings";
import Tickets from "./views/Support_tickets/Tickets";
import Master_new_customer from "./views/General_Settings/Master_new_customer";
import Shipment_report from "./views/Reports/Shipment_report";
import Payment_report from "./views/Reports/Payment_report";
import Ship_3 from "./views/Shipments/Ship_3";
import Ship_4 from "./views/Shipments/Ship_4";
import Dispatcher from "./views/Users/Dispatcher";
import Assign_customer from "./views/Users/Assign_customer";
import Daily_shipment_summary from "./views/Daily_shipment_summary";
import Delivered_shipments from "./views/Shipments/Delivered_shipments";
import Undelivered_shipments from "./views/Shipments/Undelivered_shipments";
import Dispatcher_customers from "./views/Customers/Dispatcher_customers";
import Search_pincode from "./views/location/Search_pincode";
import Missing_pincodes from "./views/General_Settings/Missing_pincodes";
import Pending_kyc from "./views/Customers/Pending_kyc";
import Kyc_detail from "./views/General_Settings/Kyc_detail";
import Add_warehouse from "./views/General_Settings/Add_warehouse";
import Allot_warehouse from "./views/General_Settings/Allot_warehouse";
import Store_keeper from "./views/Users/Store_keeper";
import Allot_warehouse_store_keeper from "./views/General_Settings/Allot_warehouse_store_keeper";
import Add_category from "./views/General_Settings/Add_category";
import Confirm_stock from "./views/General_Settings/Confirm_stock";
import B2b_Product_details from "./views/Product_management/B2b_product_details";
import Inventory from "./views/Inventory_management/Inventory";
import Product_detail_warehouse from "./views/Inventory_management/Product_detail";
import Store_keeper_inventory from "./views/Inventory_management/Store_keeper_inventory";
import Store_keeper_product_detail_warehouse from "./views/Inventory_management/Store_keeper_product_detail";
import Customer_invoices from "./views/Invoices/Customer_invoices";
import Invoice_vendor from "./views/Invoices/Invoice_vendor";
import Ndr_shipments from "./views/Shipments/Ndr_shipments";
import Weight_discrepencies_dispute from "./views/General_Settings/Weight_discrepencies_dispute";
import Local_zone from "./views/Product_management/Local_zone";
import Group_pincodes from "./views/Product_management/Group_pincodes";
import Group_import_process from "./views/Product_management/Group_import_process";
import Group_log_view from "./views/Product_management/Group_log_view";
import International_zone from "./views/Product_management/International_zone";
import Assign_international_zone from "./views/Product_management/Assign_international_zone";
import International_Product_details from "./views/Product_management/International_product_details";
import Pricing_chart from "./views/General_Settings/Pricing_chart";
import Payout from "./views/Payouts_management/Payout";
import Payouts_trans_list from "./views/Payouts_management/Payouts_trans_list";
import Payout_import_log from "./views/Payouts_management/Payout_import_log";
import Payout_detail from "./views/Payouts_management/Payout_detail";
import Payout_log_detail from "./views/Payouts_management/Payout_log_detail";
import Cod_mismatch from "./views/Payouts_management/Cod_mismatch";
import Failed_shipments from "./views/Shipments/Failed_shipments";
import Announcement from "./views/Announcement/Announcement";
import News_management from "./views/Web_Management/Home_content";
import Customer_rating from "./views/Web_Management/Testimonials";
import Weight_discrepancies_b2b from "./views/General_Settings/Weight_discrepancies_b2b";
import Weight_discrepencies_dispute_b2b from "./views/General_Settings/Weight_discrepencies_dispute_b2b";
import Payouts_referral from "./views/Payout_referral/Payouts_referral";
import Payouts_referral_trans_list from "./views/Payout_referral/Payouts_referral_trans_list";
import My_referrals from "./views/My_referrals";
import My_earnings from "./views/My_earnings";
import Special_zone_2 from "./views/Product_management/Special_zone_2";
import Rto_Product_details from "./views/Product_management/Rto_product_details";
import Rto_Product_detail from "./views/Product_management/Rto_product_detail";
import Add_b2b_product from "./views/Product_management/Add_b2b_product";
import B2b_rate_calculator from "./views/B2b_rate_calculator";
import B2b_other_pricing from "./views/Product_management/B2b_other_pricing";
import B2b_zone_management from "./views/Product_management/B2b_zone_management";
import Assign_b2b_zone from "./views/Product_management/Assign_b2b_zone";
import B2b_pricing_details from "./views/Product_management/B2b_pricing_details";
import Oda_pincode_import_process from "./views/General_Settings/Oda_pincode_import_process";
import Post_delivery_pricing from "./views/Product_management/Post_delivery_pricing";
import Vas_charges_product from "./views/Product_management/Vas_charges_product";
import Customer_b2b_pricing_details from "./views/Product_management/Customer_b2b_pricing_details";
import Customer_b2b_other_pricing from "./views/Product_management/Customer_b2b_other_pricing";
import Auto_post_delivery from "./views/Product_management/Auto_post_delivery";
import VasChargesLogs from "./views/Product_management/VasChargesLogs";
import Call from "./views/call";
import Ndr_dashboard from "./views/Ndr_dashboard";
import PrePayoutSummary from "./views/Payouts_management/PrePayoutSummary";
import High_risk_pincode from "./views/location/High_risk_pincode";
import Oda_picode_Log from "./views/General_Settings/Oda_picode_Log";
import Carousel_setup from "./views/Carousel_setup";
import Vas_prices from "./views/General_Settings/Vas_prices";
import Lead_form from "./views/Lead/Lead_form";
import State_zone from "./views/Product_management/State_zone";
import BulkPricingUpload from "./views/Product_management/BulkPricingUpload";
import ClientPricing from "./views/ClientPricing";
import Notification_log from "./views/Notification/Notification_log";
import Subscription_log from "./views/General_Settings/Subscription_log";
import Vas_log from "./views/General_Settings/Vas_logs";
import PayoutPreview from "./views/Payouts_management/PayoutPreview";
import Invoice from "./views/Invoices_v2/Invoice";
import InvoiceView from "./views/Invoices_v2/InvoiceView";

import Invoice_new from "./views/Invoices_v1.1/Invoice_new";
import InvoiceView_new from "./views/Invoices_v1.1/InvoiceView_new";
import Return_list from "./views/Shipments/Return_list";
function App() {
  const userDetail = localStorage.getItem("admin_login");
  const isLoggedIn = Boolean(userDetail);

  console.log("userDetail 111===>   ", userDetail);
  console.log("isLoggedIn 111===>   ", isLoggedIn);

  return (
    <Provider store={Store}>
      <Router>
        <Routes>
          {isLoggedIn ? (
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          ) : (
            <Route path="/" element={<Navigate to="/login" replace />} />
          )}
          <Route exact path="/dashboard" element={<Index />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/forgot-password" element={<Forgot_password />} />
          <Route exact path="/categories" element={<Categories />} />
          <Route
            exact
            path="/subcategories/:category_id"
            element={<Subcategories />}
          />
          <Route
            exact
            path="/attributes/:subcategory_id/:category_id"
            element={<Attributes />}
          />
          <Route
            exact
            path="/addgroupvalue/:subcategory_id/:category_id/:attribute_id"
            element={<Add_group_value />}
          />
          <Route exact path="/left_panel" element={<Left_panel />} />
          <Route exact path="/sub_header" element={<Sub_header />} />
          <Route exact path="/country_list" element={<Country_list />} />
          <Route
            exact
            path="/state_list/:country_id"
            element={<State_list />}
          />
          <Route
            exact
            path="/city_list/:country_id/:state_id"
            element={<City_list />}
          />
          <Route
            exact
            path="/postalcodes/:country_id/:state_id/:city_id"
            element={<PostalCodes />}
          />
          <Route exact path="/master_settings" element={<Master_settings />} />
          <Route
            exact
            path="/payment_settings"
            element={<Payment_settings />}
          />
          <Route exact path="/social_settings" element={<Social_settings />} />
          <Route exact path="/system_settings" element={<System_settings />} />
          <Route exact path="/smtp_settings" element={<Smtp_settings />} />
          <Route exact path="/shipments" element={<Shipments />} />
          <Route exact path="/orders" element={<My_orders />} />
          <Route
            exact
            path="/shipment_detail/:invoice_id"
            element={<Shipment_detail />}
          />
          <Route exact path="/payments" element={<Payments />} />
          <Route exact path="/user_cod_wallet" element={<User_cod_wallet />} />
          <Route exact path="/wallet_payments" element={<Wallet_payment />} />
          <Route
            exact
            path="/payment_gateway_payments"
            element={<Payment_gateway />}
          />
          <Route exact path="/admin_payments" element={<Admin_payments />} />
          <Route
            exact
            path="/transporter_payments"
            element={<Transporter_payments />}
          />
          <Route
            exact
            path="/transporter_detail/:transporter_id"
            element={<Transporter_detail />}
          />
          <Route exact path="/transporters" element={<Transporters />} />
          <Route
            exact
            path="/transporter_wallet"
            element={<Transporter_wallet />}
          />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/agents" element={<Agents />} />
          <Route exact path="/user_detail/:user_id" element={<User_detail />} />
          <Route
            exact
            path="/vehicle_attributes"
            element={<Vehicle_attributes />}
          />
          <Route
            exact
            path="/vehicle_sub_attributes/:category_id"
            element={<Vehicle_sub_attributes />}
          />
          <Route exact path="/email_template" element={<Email_template />} />
          <Route
            exact
            path="/edit_global_email_template"
            element={<Edit_global_email_template />}
          />
          <Route
            exact
            path="/edit_email_template/:email_template"
            element={<Edit_email_template />}
          />
          <Route exact path="/spam_report" element={<Spam_report />} />
          <Route exact path="/tickets" element={<Tickets />} />
          <Route exact path="/web_settings" element={<Web_management />} />
          <Route exact path="/news_management" element={<News_management />} />
          <Route exact path="/cms_settings" element={<Cms_management />} />
          <Route exact path="/my_profile" element={<My_profile />} />
          <Route exact path="/change_password" element={<Change_password />} />
          <Route exact path="/models_pop" element={<Models_pop />} />
          <Route exact path="/edit_cms/:cms_id" element={<Cms_edit />} />
          <Route exact path="/customer_ratings" element={<Customer_rating />} />
          <Route exact path="/ckemail" element={<Ck_email_template />} />
          <Route exact path="/customers" element={<Customers />} />
          <Route
            exact
            path="/missing_pincodes"
            element={<Missing_pincodes />}
          />
          <Route
            exact
            path="/delivered_shipments"
            element={<Delivered_shipments />}
          />
          <Route exact path="/search_pincode" element={<Search_pincode />} />
          <Route
            exact
            path="/high_risk_pincode"
            element={<High_risk_pincode />}
          />
          <Route
            exact
            path="/oda_pincode_log/:record_id"
            element={<Oda_picode_Log />}
          />
          <Route
            exact
            path="/dispatcher_customers"
            element={<Dispatcher_customers />}
          />
          <Route
            exact
            path="/undelivered_shipments"
            element={<Undelivered_shipments />}
          />
          <Route
            exact
            path="/customers_info/:customer_id"
            element={<Customers_info />}
          />
          <Route exact path="/carrier_list" element={<Carrier_list />} />
          <Route exact path="/product_type" element={<Product_type />} />
          <Route exact path="/master" element={<Master />} />
          <Route exact path="/master_new" element={<Master_new />} />
          <Route exact path="/ndr_dashboard" element={<Ndr_dashboard />} />
          <Route
            exact
            path="/print_receipts/:shipment_id"
            element={<Print_receipts />}
          />
          <Route
            exact
            path="/print_invoice/:shipment_id"
            element={<Print_invoice />}
          />
          <Route
            exact
            path="/print_label/:shipment_id"
            element={<Print_label />}
          />
          <Route exact path="/product" element={<Product />} />
          <Route exact path="/products/:customer_id" element={<Products />} />
          <Route exact path="/add_product" element={<Add_product />} />
          <Route exact path="/add_b2b_product" element={<Add_b2b_product />} />
          <Route exact path="/assign_b2b_zone" element={<Assign_b2b_zone />} />
          <Route
            exact
            path="/b2b_zone_management"
            element={<B2b_zone_management />}
          />
          <Route
            exact
            path="/b2b_pricing_details/:product_id/:carrier_id"
            element={<B2b_pricing_details />}
          />
          <Route
            exact
            path="/customer_b2b_pricing_details/:customer_id/:product_id/:carrier_id"
            element={<Customer_b2b_pricing_details />}
          />
          <Route exact path="/lead_form" element={<Lead_form />} />
          <Route
            exact
            path="/b2b_product_other_pricing/:product_id/:carrier_id"
            element={<B2b_other_pricing />}
          />
          <Route
            exact
            path="/cusomer_b2b_product_other_pricing/:customer_id/:product_id/:carrier_id"
            element={<Customer_b2b_other_pricing />}
          />
          <Route
            exact
            path="/vas_charges_product"
            element={<Vas_charges_product />}
          />
          <Route
            exact
            path="/notification_log"
            element={<Notification_log />}
          />
          <Route
            exact
            path="/post_delivery_pricing"
            element={<Post_delivery_pricing />}
          />
          <Route exact path="/client_pricing" element={<ClientPricing />} />
          <Route exact path="/payout_preview" element={<PayoutPreview />} />
          <Route
            exact
            path="/subscription_logs"
            element={<Subscription_log />}
          />
          <Route exact path="/vas_logs" element={<Vas_log />} />
          vas_logs
          <Route
            exact
            path="/auto_post_delivery_pricing"
            element={<Auto_post_delivery />}
          />
          <Route
            exact
            path="/vas_charges_logs/:fileId"
            element={<VasChargesLogs />}
          />
          <Route exact path="/call" element={<Call />} />
          <Route
            exact
            path="/edit_product/:product_id/:carrier_id"
            element={<Edit_product />}
          />
          <Route
            exact
            path="/product_detail/:customer_id/:product_id/:carrier_id"
            element={<Product_detail />}
          />
          <Route
            exact
            path="/product_details/:product_id/:carrier_id"
            element={<Product_details />}
          />
          <Route
            exact
            path="/international_product_details/:product_id/:carrier_id"
            element={<International_Product_details />}
          />
          <Route
            exact
            path="/b2b_product_details/:product_id/:carrier_id"
            element={<B2b_Product_details />}
          />
          <Route
            exact
            path="/product_details_source_city/:product_id/:carrier_id"
            element={<Product_details_source_city />}
          />
          <Route
            exact
            path="/product_details_zone/:product_id/:carrier_id/:source_city_id"
            element={<Product_details_zone />}
          />
          <Route
            exact
            path="/import_process/:product_id/:carrier_id/:source_city_id"
            element={<Import_process />}
          />
          <Route
            exact
            path="/log_view/:product_id/:carrier_id/:source_city_id"
            element={<Log_view />}
          />
          <Route exact path="/zone_calculator" element={<Rate_calculator />} />
          <Route
            exact
            path="/b2b_zone_calculator"
            element={<B2b_rate_calculator />}
          />
          <Route exact path="/inventory_management" element={<Inventory />} />
          <Route exact path="/ship_1" element={<Ship_1 />} />
          <Route exact path="/ship_2" element={<Ship_2 />} />
          <Route exact path="/package_list" element={<Package_list />} />
          <Route exact path="/payment_details" element={<Payment_details />} />
          <Route
            exact
            path="/weight_discrepancies"
            element={<Weight_discrepancies />}
          />
          <Route
            exact
            path="/weight_discrepancies_b2b"
            element={<Weight_discrepancies_b2b />}
          />
          <Route
            exact
            path="/weight_discrepancies_log/:record_id"
            element={<Weight_discrepancies_log />}
          />
          <Route
            exact
            path="/customer_kyc_settings"
            element={<Customer_kyc_settings />}
          />
          <Route
            exact
            path="/new_customer_registration"
            element={<New_custromer_registration />}
          />
          <Route
            exact
            path="/sms_gateway_settings"
            element={<Sms_gateway_settings />}
          />
          <Route exact path="/address_book" element={<My_address />} />
          <Route
            exact
            path="/summary/:record_id/:customer_id"
            element={<Summary />}
          />
          <Route exact path="/zone_list" element={<Zone_management />} />
          <Route exact path="/vas_prices" element={<Vas_prices />} />
          <Route
            exact
            path="/special_zone/:zone_id"
            element={<Special_zone />}
          />
          <Route exact path="/state_zone/:zone_id" element={<State_zone />} />
          <Route
            exact
            path="/rto_product_details/:product_id/:carrier_id"
            element={<Rto_Product_details />}
          />
          <Route
            exact
            path="/rto_product_detail/:customer_id/:product_id/:carrier_id"
            element={<Rto_Product_detail />}
          />
          <Route
            exact
            path="/special_zone_2/:zone_id"
            element={<Special_zone_2 />}
          />
          <Route
            exact
            path="/group_pincodes/:zone_id/:group_id"
            element={<Group_pincodes />}
          />
          <Route exact path="/local_zone/:zone_id" element={<Local_zone />} />
          <Route
            exact
            path="/metro_to_metro/:zone_id"
            element={<Zone_metro_to_metro />}
          />
          <Route
            exact
            path="/special_zone_import_process/:zone_id"
            element={<Special_zone_import_process />}
          />
          <Route
            exact
            path="/group_import_process/:zone_id/:group_id"
            element={<Group_import_process />}
          />
          <Route exact path="/pricing_chart" element={<Pricing_chart />} />
          <Route
            exact
            path="/group_log_view/:zone_id/:group_id/:record_id"
            element={<Group_log_view />}
          />
          <Route
            exact
            path="/international_zone_management"
            element={<International_zone />}
          />
          <Route
            exact
            path="/assign_international_zone"
            element={<Assign_international_zone />}
          />
          <Route
            exact
            path="/special_zone_log_view/:zone_id/:record_id"
            element={<Special_zone_log_view />}
          />
          <Route
            exact
            path="/metro_import_process/:zone_id"
            element={<Metro_import_process />}
          />
          <Route
            exact
            path="/metro_log_view/:zone_id/:record_id"
            element={<Metro_zone_log_view />}
          />
          <Route
            exact
            path="/servicable_pincode_import_process/:carrier_id"
            element={<Servicable_pincode_import_process />}
          />
          <Route
            exact
            path="/oda_pincode_import_process/:carrier_id"
            element={<Oda_pincode_import_process />}
          />
          <Route
            exact
            path="/bulk_pricing_upload_log"
            element={<BulkPricingUpload />}
          />
          <Route
            exact
            path="/servicable_carriers"
            element={<Servicable_pincodes />}
          />
          <Route
            exact
            path="/servicable_pincodes/:carrier_id"
            element={<Servicable_pincodes_list />}
          />
          <Route
            exact
            path="/master_new_customer/:customer_id"
            element={<Master_new_customer />}
          />
          <Route exact path="/shipment_report" element={<Shipment_report />} />
          <Route exact path="/payment_report" element={<Payment_report />} />
          <Route exact path="/ship_3" element={<Ship_3 />} />
          <Route exact path="/ship_4" element={<Ship_4 />} />
          <Route exact path="/dispatchers" element={<Dispatcher />} />
          <Route exact path="/add_warehouse" element={<Add_warehouse />} />
          <Route exact path="/ndr_shipments" element={<Ndr_shipments />} />
          <Route exact path="/return_shipments" element={<Return_list />} />
          <Route
            exact
            path="/assign_customer/:dispatcher_id"
            element={<Assign_customer />}
          />
          <Route exact path="/pending_kyc" element={<Pending_kyc />} />
          <Route exact path="/carousel_setup" element={<Carousel_setup />} />
          <Route exact path="/store_keeper" element={<Store_keeper />} />
          <Route exact path="/category" element={<Add_category />} />
          <Route exact path="/confirm_stock" element={<Confirm_stock />} />
          <Route exact path="/my_referrals" element={<My_referrals />} />
          <Route exact path="/my_earnings" element={<My_earnings />} />
          <Route
            exact
            path="/payouts_referral"
            element={<Payouts_referral />}
          />
          <Route
            exact
            path="/payouts_refer_trans_list/:payout_referral_id"
            element={<Payouts_referral_trans_list />}
          />
          <Route
            exact
            path="/weight_discrepancies_dispute"
            element={<Weight_discrepencies_dispute />}
          />
          <Route
            exact
            path="/weight_discrepancies_dispute_b2b"
            element={<Weight_discrepencies_dispute_b2b />}
          />
          <Route
            exact
            path="/product_detail_store_keeper_warehouse/:product_id"
            element={<Store_keeper_product_detail_warehouse />}
          />
          <Route
            exact
            path="/store_keeper_inventory"
            element={<Store_keeper_inventory />}
          />
          <Route
            exact
            path="/product_detail_warehouse/:product_id"
            element={<Product_detail_warehouse />}
          />
          <Route
            exact
            path="/allot_warehouse_to_customer/:address_id"
            element={<Allot_warehouse />}
          />
          <Route
            exact
            path="/allot_warehouse_to_store_keeper/:address_id"
            element={<Allot_warehouse_store_keeper />}
          />
          <Route
            exact
            path="/kyc_detail/:customer_id"
            element={<Kyc_detail />}
          />
          <Route exact path="/payout" element={<Payout />} />
          <Route
            exact
            path="/payouts_trans_list/:payout_id"
            element={<Payouts_trans_list />}
          />
          <Route
            exact
            path="/payout_import_log/:payout_id"
            element={<Payout_import_log />}
          />
          <Route
            exact
            path="/prepayoutSummary"
            element={<PrePayoutSummary />}
          />
          <Route
            exact
            path="/payout_detail/:payout_id/:customer_id"
            element={<Payout_detail />}
          />
          <Route
            exact
            path="/payout_log_detail/:payout_id/:record_id"
            element={<Payout_log_detail />}
          />
          <Route
            exact
            path="/daily_shipment_summary"
            element={<Daily_shipment_summary />}
          />
          <Route exact path="/invoices" element={<Customer_invoices />} />
          <Route exact path="/invoices_v2" element={<Invoice />} />
          {/* <Route exact path="/invoices_v1.1" element={<Invoice_new />} /> */}
          <Route
            exact
            path="/invoice_view/:invoice_id"
            element={<InvoiceView />}
          />
          <Route
            exact
            path="/invoice_view_new_v1.1/:invoice_id"
            element={<InvoiceView_new />}
          />
          <Route exact path="/cod_mismatch" element={<Cod_mismatch />} />
          <Route exact path="/invoice_detail" element={<Invoice_vendor />} />
          <Route exact path="/announcement" element={<Announcement />} />
          <Route
            exact
            path="/failed_shipments"
            element={<Failed_shipments />}
          />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
